import React from 'react'
import ZazzleLogo from 'src/assets/icons/ico-zazzle-logo.svg'
import HobnobLogo from 'src/assets/icons/ico-hobnob-logo.svg'
import AndIcon from 'src/assets/icons/ico-and.svg'
import styles from './zazzle-and-hobnob-logo.scss'
import SvgIcon from 'src/components/common/SvgIcon'
import PropTypes from 'prop-types'

const ZazzleAndHobnobLogo = ({
  logoContainerClassName,
  zazzleLogoClassName,
  andIconClassName,
  hobnobLogoClassName
}) => {
  return (
    <div className={`${styles['logo-container']} ${logoContainerClassName || ''}`}>
      <SvgIcon className={`${styles['zazzle-logo']} ${zazzleLogoClassName || ''}`} icon={ZazzleLogo} />
      <SvgIcon className={`${styles['and-icon']} ${andIconClassName || ''}`} icon={AndIcon} />
      <SvgIcon className={`${styles['hobnob-logo']} ${hobnobLogoClassName || ''}`} icon={HobnobLogo} />
    </div>
  )
}

ZazzleAndHobnobLogo.propTypes = {
  logoContainerClassName: PropTypes.string,
  zazzleLogoClassName: PropTypes.string,
  andIconClassName: PropTypes.string,
  hobnobLogoClassName: PropTypes.string
}

export default ZazzleAndHobnobLogo
